import type { LocalDate } from '../dates';
import type { WeightSettings } from './types';

export interface GoalProgress {
  goalG: number;
  startG: number;
  startDate: LocalDate | null;
  currentG: number;
  /** 'lose' when the goal is below the start, else 'gain'. */
  direction: 'lose' | 'gain';
  /** Share of the way from start to goal, 0 to 1 (never below 0, capped at 1). */
  fraction: number;
  /** Grams still to go toward the goal (0 once reached). */
  remainingG: number;
  reached: boolean;
}

/**
 * Progress from where the goal started toward it. `currentG` is the 7-day average when there is
 * one (trend, not noise), else the latest weigh-in.
 */
export function goalProgress(
  settings: WeightSettings,
  currentG: number | null,
): GoalProgress | null {
  const { goalG, goalStartG } = settings;
  if (goalG === null || goalStartG === null || currentG === null) return null;
  const direction = goalG < goalStartG ? 'lose' : 'gain';
  const total = Math.abs(goalStartG - goalG);
  const done = direction === 'lose' ? goalStartG - currentG : currentG - goalStartG;
  const remainingG = Math.max(0, direction === 'lose' ? currentG - goalG : goalG - currentG);
  const reached = remainingG === 0;
  const fraction = reached || total === 0 ? 1 : Math.min(1, Math.max(0, done / total));
  return {
    goalG,
    startG: goalStartG,
    startDate: settings.goalStartDate,
    currentG,
    direction,
    fraction,
    remainingG,
    reached,
  };
}
